import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { copyText } from "@/lib/clipboard";

// Inline ID cell for tables: shows the full value (truncates visually but reveals
// the complete string on hover) with a one-click copy button right beside it.
export function IdCell({ value, strong = false, testId = "id-cell", maxWidth = 260 }) {
  const [done, setDone] = useState(false);
  if (!value) return <span className="text-muted-foreground/50">—</span>;
  const copy = (e) => {
    e?.stopPropagation();
    copyText(value);
    setDone(true);
    setTimeout(() => setDone(false), 1200);
  };
  return (
    <span className="group/id inline-flex items-center gap-1.5" style={{ maxWidth }} data-testid={testId}>
      <span title={value}
        className={`truncate font-mono text-xs ${strong ? "font-medium text-foreground" : "text-muted-foreground/80"} group-hover/id:text-foreground`}>
        {value}
      </span>
      <button type="button" onClick={copy} title="Copy full value" data-testid={`${testId}-copy`}
        className="shrink-0 text-muted-foreground/60 transition-colors hover:text-foreground">
        {done ? <Check className="h-3 w-3 text-[#22C55E]" /> : <Copy className="h-3 w-3" />}
      </button>
    </span>
  );
}
